module.exports = __webpack_public_path__ + "img/sickness.2666e424.png";